import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Box from 'components/Box';
import { IApiHistoryCallerIdParams } from 'services/types/caller';
import styled from 'styled-components';
import { IUICallerIdHistoryItem } from 'types/customer';
const columns: ColumnsType<IUICallerIdHistoryItem> = [
  {
    title: 'DATE',
    dataIndex: 'date',
    key: 'date',
  },

  {
    title: 'TIME',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: 'NAME',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'PHONE',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'CUSTOMER TYPE',
    dataIndex: 'customerType',
    key: 'customerType',
    width: '175px',
    render(value) {
      return <Box display='flex' justifyContent='center' alignItems='center'><CustomerType className={value}><span>{value}</span></CustomerType></Box>;
    },
  },
];
type Props = {
  dataSource: IUICallerIdHistoryItem[];
  loading?: boolean;
  totalItems: number;
  onChangePage: (page: number) => void;
  params: IApiHistoryCallerIdParams;
};
const CallerIdHistoryTable = ({ dataSource, loading, totalItems, onChangePage, params }: Props) => {

  return (
    <TableStyled
      dataSource={dataSource}
      columns={columns as any}
      style={{ width: '100%' }}
      loading={loading}
      pagination={{
        total: totalItems,
        pageSize: 10,
        current: params.page,
        showSizeChanger: false,
        onChange: onChangePage,
      }}
    />
  );
};

export default CallerIdHistoryTable;

const CustomerType = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #EBFFF0;
  span {
    color: #00A140;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &.new {
    background: #FFEFEB;
    span {
      color: #D2390E;
    }
  }
`;

const TableStyled = styled(Table)`
  background: #fff;
  .ant-table {
    .ant-table-container .ant-table-content {
      thead.ant-table-thead th.ant-table-cell {
        padding: 4px 8px;
        align-items: center;
        gap: 4px;
        align-self: stretch;
        border-right: 1px solid #F1F1F1;
        background: #1D2129;

        color: #FFF;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      tbody.ant-table-tbody tr:nth-child(even) td{
        background: #E8F3FF;
      }


    }
  }
`;